module.exports = __webpack_public_path__ + "media/img/partners/virtual-internships-logo-224adf81bbd719b861524bf8af531e9f.png";